import { ExtratoRepasseExternoV2State } from '../../types/state.types';
import { StoreAction } from '../reduxTypes';
import * as actions from './actions';

const initialState: ExtratoRepasseExternoV2State = {
  requisitado: false,
  filtros: {
    competencia: "",
    lotacaoId: undefined,
    dataPagamento: "",
  },
  listaLotacoes: [],
  listaDatasPagamento: [],
  listaCompetencias: [],
  dadosExtrato: undefined,
  loading: false,
}

const reducer = (
  state: ExtratoRepasseExternoV2State = initialState,
  action: StoreAction,
): ExtratoRepasseExternoV2State => {
  switch (action.type) {
    case actions.EXTRATO_REPASSE_EXTERNO_V2__INICIALIZA_ESTADO:
      return {
        ...state,
        requisitado: true,
      }

    case actions.EXTRATO_REPASSE_EXTERNO_V2__SET_COMPETENCIAS:
      return {
        ...state,
        listaCompetencias: [
          ...action.payload
        ],
      }

    case actions.EXTRATO_REPASSE_EXTERNO_V2__SET_LOTACOES:
      return {
        ...state,
        listaLotacoes: [
          ...action.payload
        ],
      }

    case actions.EXTRATO_REPASSE_EXTERNO_V2__SET_DATAS_PAGAMENTO:
      return {
        ...state,
        listaDatasPagamento: [
          ...action.payload
        ],
      }

    case actions.EXTRATO_REPASSE_EXTERNO_V2__SET_DADOS_EXTRATO:
      return {
        ...state,
        dadosExtrato: action.payload,
      }

    case actions.EXTRATO_REPASSE_EXTERNO_V2__SET_FILTROS:
      return {
        ...state,
        filtros: action.payload,
        dadosExtrato: initialState.dadosExtrato,
      }

    case 'SESSION__LOGOUT':
      return initialState;
  
    case actions.EXTRATO_REPASSE_EXTERNO_V2__LIMPAR_FILTROS:
      return {
        ...state,
        filtros: initialState.filtros,
      }
  
    case actions.EXTRATO_REPASSE_EXTERNO_V2__SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    default:
      return state;
  }
}

export default reducer;
